/**
 * A response the server refused, with its status and its own reason.
 *
 * `message` stays what the callers always showed — the server's reason, or the
 * fallback — so a screen that only wants a sentence needs nothing new.
 */
export class HttpError extends Error {
    /**
     * Fields rather than constructor parameter properties: `erasableSyntaxOnly`
     * allows no shorthand that emits code.
     */
    readonly status: number;
    /** The `error` field of the response body, when the server sent one. */
    readonly reason: string | null;

    constructor(status: number, reason: string | null, fallback: string) {
        super(reason || fallback);
        this.name = 'HttpError';
        this.status = status;
        this.reason = reason;
    }
}

/** The refusal in `response`, its body read for the server's reason. */
export async function httpErrorOf(
    response: Response,
    fallback: string
): Promise<HttpError> {
    const data: { error?: unknown } = await response.json().catch(() => ({}));
    const reason =
        typeof data.error === 'string' && data.error ? data.error : null;
    return new HttpError(response.status, reason, fallback);
}
